export { default } from './GenericError';
